import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { ChatCircleDots, CalendarCheck, SignOut, UserCircle, ShieldStar } from "@phosphor-icons/react";
import { NotificationBell } from "./NotificationBell";
import { useSettings } from "../context/SettingsContext";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const brand = settings?.site_name || "Lomar Properties";
  return (
    <header className="glass sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src="/lomar-logo.png" alt={brand} className="h-11 w-auto rounded-lg" />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <Link to="/catalog" data-testid="nav-catalog">
            <Button variant="ghost" className="text-stone-700 hover:text-orange-800 hover:bg-orange-50">Explorer</Button>
          </Link>
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin">
                  <Button variant="ghost" className="text-stone-700 hover:text-orange-800 hover:bg-orange-50"><ShieldStar size={18} className="mr-1" /> Admin</Button>
                </Link>
              )}
              {user.role === "seller" && (
                <Link to="/dashboard" data-testid="nav-dashboard">
                  <Button variant="ghost" className="text-stone-700 hover:text-orange-800 hover:bg-orange-50">Mon espace</Button>
                </Link>
              )}
              <NotificationBell />
              <Link to="/messages" data-testid="nav-messages">
                <Button variant="ghost" size="icon" className="text-stone-700 hover:text-orange-800"><ChatCircleDots size={22} /></Button>
              </Link>
              <Link to="/bookings" data-testid="nav-bookings">
                <Button variant="ghost" size="icon" className="text-stone-700 hover:text-orange-800"><CalendarCheck size={22} /></Button>
              </Link>
              <span className="hidden sm:flex items-center gap-1 text-sm text-stone-600 ml-2">
                <UserCircle size={20} /> {user.name?.split(" ")[0]}
              </span>
              <Button data-testid="nav-logout" variant="ghost" size="icon" onClick={async () => { await logout(); navigate("/"); }}
                className="text-stone-700 hover:text-orange-800"><SignOut size={20} /></Button>
            </>
          ) : (
            <Link to="/auth" data-testid="nav-login">
              <Button className="rounded-full bg-orange-800 hover:bg-orange-900 text-white px-6">Connexion</Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
